import { render, staticRenderFns } from "./ContactTable.vue?vue&type=template&id=3f24a1b9"
import script from "./ContactTable.vue?vue&type=script&lang=ts"
export * from "./ContactTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports